import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as taskActions from '../../../actions/taskActions';
import * as classroomApi from '../../../services/api/classroomApi';
import { TASK_TABS_CONSTANTS } from '../../../const';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class RemoveAssignmentReveal extends React.Component {
  static propTypes = {
    classroom: PropTypes.object,
    taskActions: PropTypes.any,
    modalOpenTask: PropTypes.any,
    currentTasks: PropTypes.object,
    finishedTasks: PropTypes.object,
    futureTasks: PropTypes.object,
    activeTaskTab: PropTypes.string,
    user: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.onDeleteAssignment = this.onDeleteAssignment.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  onDeleteAssignment() {
    const { modalOpenTask, taskActions, classroom, activeTaskTab, user } = this.props;
    taskActions.setModalOpenTask(false);
    classroomApi.deleteAssignment(modalOpenTask).then(async () => {
      await this.calculateNewPage();

      if (activeTaskTab === TASK_TABS_CONSTANTS.FINISHED.key) {
        taskActions.getFinishedAssignments(classroom.id, user._id);
      } else if (activeTaskTab === TASK_TABS_CONSTANTS.IN_PROGRESS.key) {
        taskActions.getCurrentAssignments(classroom.id, user._id);
      } else if (activeTaskTab === TASK_TABS_CONSTANTS.FUTURE.key) {
        taskActions.getFutureAssignments(classroom.id, user._id);
      }
    });
  }

  calculateNewPage = async () => {
    const { taskActions, currentTasks, finishedTasks, activeTaskTab, futureTasks } = this.props;
    if (activeTaskTab === TASK_TABS_CONSTANTS.FINISHED.key) {
      let currentPage = finishedTasks.currentPage;
      if (finishedTasks.tasks.length === 1 && currentPage !== 0) {
        return await taskActions.setFinishedTasksCurrentPage(currentPage - 1);
      }
    } else if (activeTaskTab === TASK_TABS_CONSTANTS.IN_PROGRESS.key) {
      let currentPage = currentTasks.currentPage;
      if (currentTasks.tasks.length === 1 && currentPage !== 0) {
        return await taskActions.setCurrentTasksCurrentPage(currentPage - 1);
      }
    } else if (activeTaskTab === TASK_TABS_CONSTANTS.FUTURE.key) {
      let currentPage = futureTasks.currentPage;
      if (futureTasks.tasks.length === 1 && currentPage !== 0) {
        return await taskActions.setFutureTasksCurrentPage(currentPage - 1);
      }
    }
  };

  closeModal() {
    const { taskActions } = this.props;
    taskActions.setModalOpenTask();
  }

  render() {
    const { modalOpenTask } = this.props;

    return (
      <Modal
        id="remove-assignment"
        title={I18n.t('removeAssignmentPopup.deleteAssigment')}
        active={!!modalOpenTask}
        onClickOutside={this.closeModal}
        children={<Paragraph className="text-grey-700">{I18n.t('removeAssignmentPopup.deleteSure')}</Paragraph>}
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button onClick={this.onDeleteAssignment} primary label={I18n.t('common.delete')}></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    classroom: state.classrooms.selectedClassroom.classroom,
    colors: state.theme.colors,
    i18n: state.i18n,
    modalOpenTask: state.task.modalOpenTask,
    currentTasks: state.task.currentTasks,
    finishedTasks: state.task.finishedTasks,
    activeTaskTab: state.task.activeTaskTab,
    futureTasks: state.task.futureTasks,
    user: state.account.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    taskActions: bindActionCreators(taskActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RemoveAssignmentReveal);
